<mat-dialog-content class="main">
    <div
            class="body"
            [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(message || '<p></p>')"
    >
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="dialogActions">
    <button mat-button mat-dialog-close tabindex="-1">{{"close" | translate}}</button>
</mat-dialog-actions>